import imgmonard81 from "./monard-8.webp"
import imgmonard82 from "./monard-8 (2).webp"
import imgmonard83 from "./monard-8 (3).webp"
import imgmonard84 from "./monard-8 (4).webp"
import imgmonard85 from "./monard-8 (5).webp"

const imgmonard8 = [
    imgmonard81,
    imgmonard82,
    imgmonard83,
    imgmonard84,
    imgmonard85,
]

export default imgmonard8